// Rasterizes a DOM node into a branded PNG and shares/downloads it.
export async function generateShareImage(node, filename = "the-cardlight-reading.png") {
  const html2canvas = (await import("html2canvas")).default;
  const canvas = await html2canvas(node, {
    backgroundColor: "#0B0C15",
    scale: 2,
    useCORS: true,
    logging: false,
  });
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) throw new Error("Failed to render image");

  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "My reading from The Cardlight" });
      return "shared";
    } catch (err) {
      // User cancelled or share failed — fall through to download.
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return "downloaded";
}
